// Generated with util/create-component.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, Redirect } from 'react-router-dom';
import { Typography } from 'antd';

import LoginForm from 'src/components/LoginForm/LoginForm';
import { ILoginParams } from 'src/components/LoginForm/LoginForm.types';
import env from 'src/env';
import { useAuth } from 'src/hooks/useAuth';

import { ILoginPageProps } from './LoginPage.types';
import styles from './LoginPage.module.scss';

const { Title } = Typography;

const LoginPage: React.FC<ILoginPageProps> = () => {
  const location = useLocation<{ from: { pathname: string } }>();
  const auth = useAuth();
  const { t } = useTranslation();

  const { from } = location.state || { from: { pathname: '/' } };

  if (auth.isAuthenticated) {
    return <Redirect to={from} />;
  }

  return (
    <div data-testid="LoginPage" className={styles.root}>
      <div className={styles.login_container}>
        <div className={styles.logo_container}>
          <img src={`${env.apiBaseUrl}/api/public/v1/big_logo`} alt="logo" className={styles.logo} />
          <Title className={styles.title}>{t('housekeeping.general.housekeeping')}</Title>
        </div>
        <LoginForm onLogin={handleLogin} onPasswordReset={handlePasswordReset} otpSent={auth.otp_sent} />
      </div>
    </div>
  );

  async function handleLogin(params: ILoginParams) {
    await auth.login(params);
  }

  async function handlePasswordReset(email: string) {
    await auth.resetPassword(email);
  }
};

export default LoginPage;
